import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/zoekmotorLayoutActions";

class AfgelopenPage extends React.Component {
    componentDidMount() {
        this.props.loadLayout();
    }

    render() {
        return (
            <section className="o-page__main u-clear" role="main">
                <div className="c-section-wrap">
                    <div className="c-section c-section--pink">
                        <header className="c-section__header">
                            <h2 className="title">Error 410</h2>
                        </header>
                        <div className="c-section__body" style={{ textAlign: 'center' }}>
                            <div className="c-content-block">
                                <span className="error">Deze pagina bestaat niet meer.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

AfgelopenPage.propTypes = {
    loadLayout: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadExceptionPageLayout, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(AfgelopenPage);
